import { addToast } from "@caprikorn/dynamo-ui";
import { useMutation } from "@tanstack/react-query";

import { LS_KEYS } from "@core/core.constants";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import { unauthenticatedApiEcmsHttp } from "../http";
import { QUERY_KEYS } from "../keys";
import type { PostPublicLogin } from "./apiEcms.types";

const postPublicLogin = async (email: string, password: string) => {
  const { data } = await unauthenticatedApiEcmsHttp.post<PostPublicLogin>(
    "/public/login",
    {
      login: email,
      password,
    },
  );

  return data;
};

export const usePostPublicLogin = () => {
  const { t } = useCustomTranslation("main");

  return useMutation({
    mutationFn: ({ email, password }: { email: string; password: string }) =>
      postPublicLogin(email, password),
    mutationKey: [QUERY_KEYS.LOGIN],
    onMutate: (variables) => {
      // we set the email in local storage for potential first connection case
      localStorage.setItem(LS_KEYS.EMAIL, variables.email);
    },
    onSuccess: (response) => {
      localStorage.setItem(LS_KEYS.EMAIL, response.email);
      localStorage.setItem(LS_KEYS.ACCESS_TOKEN, response.accessToken);
      localStorage.setItem(LS_KEYS.REFRESH_TOKEN, response.refreshToken);
    },
    onError: () => {
      addToast({
        variant: "error",
        title: t("auth.passwordInvalidErrorTitle"),
        description: t("auth.passwordInvalidErrorDescription"),
      });
    },
  });
};
